import React from 'react';

export function Card({ children, className, isDarkMode = false, ...props }) {
  return (
    <div
      className={`${
        isDarkMode ? 'bg-gray-800 text-white' : 'bg-white text-gray-900'
      } shadow-md rounded-lg ${className}`}
      {...props}
    >
      {children}
    </div>
  );
}

export function CardHeader({ children, className, isDarkMode = false, ...props }) {
  return (
    <div
      className={`px-6 py-4 border-b ${
        isDarkMode ? 'border-gray-700' : 'border-gray-200'
      } ${className}`}
      {...props}
    >
      {children}
    </div>
  );
}

export function CardContent({ children, className, isDarkMode = false, ...props }) {
  return (
    <div
      className={`px-6 py-4 ${
        isDarkMode ? 'text-white' : 'text-gray-900'
      } ${className}`}
      {...props}
    >
      {children}
    </div>
  );
}

export function CardTitle({ children, className, isDarkMode = false, ...props }) {
  return (
    <h3
      className={`text-lg font-semibold ${
        isDarkMode ? 'text-white' : 'text-gray-900'
      } ${className}`}
      {...props}
    >
      {children}
    </h3>
  );
}

export function CardDescription({ children, className, isDarkMode = false, ...props }) {
  return (
    <p
      className={`text-sm ${
        isDarkMode ? 'text-gray-300' : 'text-gray-500'
      } ${className}`}
      {...props}
    >
      {children}
    </p>
  );
}

// import * as React from "react"
// import { cn } from "./lib/utils"

// const Card = React.forwardRef(({ className, ...props }, ref) => (
//   <div
//     ref={ref}
//     className={cn(
//       "rounded-lg border bg-card text-card-foreground shadow-sm",
//       className
//     )}
//     {...props}
//   />
// ))
// Card.displayName = "Card"

// const CardHeader = React.forwardRef(({ className, ...props }, ref) => (
//   <div
//     ref={ref}
//     className={cn("flex flex-col space-y-1.5 p-6", className)}
//     {...props}
//   />
// ))
// CardHeader.displayName = "CardHeader"

// const CardTitle = React.forwardRef(({ className, ...props }, ref) => (
//   <h3
//     ref={ref}
//     className={cn(
//       "text-2xl font-semibold leading-none tracking-tight",
//       className
//     )}
//     {...props}
//   />
// ))
// CardTitle.displayName = "CardTitle"

// const CardDescription = React.forwardRef(({ className, ...props }, ref) => (
//   <p
//     ref={ref}
//     className={cn("text-sm text-muted-foreground", className)}
//     {...props}
//   />
// ))
// CardDescription.displayName = "CardDescription"

// const CardContent = React.forwardRef(({ className, ...props }, ref) => (
//   <div ref={ref} className={cn("p-6 pt-0", className)} {...props} />
// ))
// CardContent.displayName = "CardContent"

// const CardFooter = React.forwardRef(({ className, ...props }, ref) => (
//   <div
//     ref={ref}
//     className={cn("flex items-center p-6 pt-0", className)}
//     {...props}
//   />
// ))
// CardFooter.displayName = "CardFooter"

// export { Card, CardHeader, CardFooter, CardTitle, CardDescription, CardContent }